"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButton = exports.SlidingPanelDropdown = exports.SlidingPanelHeader = exports.SlidingPanelSection = exports.SlidingPanelPageContent = exports.SlidingPanelPage = exports.SlidingPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var R = __importStar(require("../../utils/ramda"));
require("./SlidingPanel.css");
var Stack_1 = require("../../components/Stack");
var Row_1 = require("../../components/Row");
var classnames_1 = __importDefault(require("classnames"));
var Badge_1 = require("../../components/Badge");
var MDIcon_1 = require("../../components/MDIcon");
var Button_1 = require("../../components/Button");
var SlidingPanel = function (_a) {
  var _b = _a.active,
    active = _b === void 0 ? false : _b,
    className = _a.className,
    restProps = __rest(_a, ["active", "className"]);
  var cn = (0, classnames_1.default)("vsx-sliding-panel", className);
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    "data-active": active,
    className: cn
  }, restProps));
};
exports.SlidingPanel = SlidingPanel;
var SlidingPanelPage = function (_a) {
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  var cn = (0, classnames_1.default)("vsx-sliding-panel-page", className);
  return (0, jsx_runtime_1.jsx)(Row_1.Row, __assign({
    className: cn
  }, restProps));
};
exports.SlidingPanelPage = SlidingPanelPage;
var SlidingPanelPageContent = function (_a) {
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  var cn = (0, classnames_1.default)("vsx-sliding-panel-page-content", className);
  return (0, jsx_runtime_1.jsx)("div", __assign({
    className: cn
  }, restProps));
};
exports.SlidingPanelPageContent = SlidingPanelPageContent;
var SlidingPanelSection = function (_a) {
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  var cn = (0, classnames_1.default)("vsx-sliding-panel-section", className);
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    className: cn
  }, restProps));
};
exports.SlidingPanelSection = SlidingPanelSection;
var SlidingPanelHeader = function (_a) {
  var className = _a.className,
    restProps = __rest(_a, ["className"]);
  var cn = (0, classnames_1.default)("vsx-sliding-panel-header", className);
  return (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
    className: cn
  }, restProps));
};
exports.SlidingPanelHeader = SlidingPanelHeader;
var SlidingPanelDropdown = function (_a) {
  var className = _a.className,
    label = _a.label,
    badge = _a.badge,
    _b = _a.startExpanded,
    startExpanded = _b === void 0 ? false : _b,
    children = _a.children,
    restProps = __rest(_a, ["className", "label", "badge", "startExpanded", "children"]);
  var _c = __read((0, react_1.useState)(startExpanded), 2),
    expanded = _c[0],
    setExpanded = _c[1];
  var cn = (0, classnames_1.default)("vsx-sliding-panel-dropdown", className);
  return (0, jsx_runtime_1.jsxs)(Stack_1.Stack, __assign({
    className: cn
  }, restProps, {
    children: [(0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
      className: "vsx-sliding-panel-dropdown-label-row",
      gap: "small",
      paddingLeft: "medium-large",
      align: "center",
      justify: "space-between",
      onClick: function () {
        return setExpanded(R.not);
      },
      wrap: false
    }, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        className: "vsx-sliding-panel-dropdown-label"
      }, {
        children: label
      })), badge && (0, jsx_runtime_1.jsx)(Badge_1.Badge, __assign({
        role: "status",
        uppercase: false,
        className: "vsx-sliding-panel-dropdown-badge"
      }, {
        children: badge
      })), (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
        className: "vsx-sliding-panel-dropdown-chevron",
        size: 40,
        icon: expanded ? "chevron-down" : "chevron-right"
      })]
    })), (0, jsx_runtime_1.jsx)(Stack_1.Stack, __assign({
      className: "vsx-sliding-panel-dropdown-children",
      "data-expanded": expanded,
      padding: "medium-large",
      paddingTop: "medium"
    }, {
      children: children
    }))]
  }));
};
exports.SlidingPanelDropdown = SlidingPanelDropdown;
var ToggleButton = function (_a) {
  var active = _a.active,
    setActive = _a.setActive,
    _b = _a.iconActive,
    iconActive = _b === void 0 ? "arrow-right" : _b,
    _c = _a.iconInactive,
    iconInactive = _c === void 0 ? "filter-variant" : _c,
    restProps = __rest(_a, ["active", "setActive", "iconActive", "iconInactive"]);
  return (0, jsx_runtime_1.jsx)(Button_1.IconButton, __assign({}, restProps, {
    icon: active ? iconActive : iconInactive,
    onClick: function () {
      return setActive(R.not);
    }
  }));
};
exports.ToggleButton = ToggleButton;